module.exports = __webpack_public_path__ + "img/pe.3a3b530a.svg";